import configs from 'config';
import ls from 'utils/secureStorage';

export const clearSession = () => {
  const URL = ls.get(configs.PERSIST_URL);
  window.location.replace(`/${URL}`);

  ls.clear();
};
